import jwtDecode from 'jwt-decode'
import { toast } from 'react-toastify'

import { getEnvironment } from 'helpers/app'
import { getRoomName } from 'helpers/room'
import {
    accessTokenHelper,
    refreshTokenHelper,
    userTypeHelper,
} from 'helpers/token'
import { isExpired, getUserTypeFromToken, userTypes } from 'helpers/user'
import { updateQRCodeInfo } from 'services/apis/user'
import { ohrAxiosOpen } from 'services/httpInstance/http'
import * as userActions from 'store/actions/User'
import avatarStore from 'utils/avatarStore'

const setUserState = (
    preferred_username,
    name,
    access_token,
    refresh_token,
    type,
    user_id
) => dispatch => {
    dispatch(userActions.setTokens({ access_token, refresh_token }))
    dispatch(userActions.setUserType(type))
    dispatch(
        userActions.setUserInfo({
            phone_number: preferred_username,
            full_name: name,
            user_id,
        })
    )
    dispatch(userActions.setAuth(true))
}

export const removeUserCookies = () => {
    accessTokenHelper.del()
    refreshTokenHelper.del()
    userTypeHelper.del()
}

const notificationOptions = {
    position: 'top-right',
}

export const handleErrorInAuth = e => dispatch => {
    toast.error('oh! you have been logged out', notificationOptions)
    dispatch(performLogout({}))
    e && console.log(e)
    window.open('/login', '_self')
}

const handleUpdateQRCodeInfo = async (dispatch, data) => {
    const environment = getEnvironment()

    if (environment) {
        const qrcodeData = {
            room: {
                name: getRoomName(),
            },
            accessToken: data.accessToken,
            env: environment.toLowerCase(),
        }

        try {
            const response = await updateQRCodeInfo(qrcodeData)

            if (response.data) {
                dispatch(
                    userActions.setQRCodeData({
                        id: response.data,
                        env: environment.toLowerCase(),
                    })
                )
            }
        } catch (error) {
            console.log('error in updating qrcode info :- ', error)
        }
    }
}

export const performLogin = data => async dispatch => {
    const { preferred_username, name, sub } = jwtDecode(data.access_token)
    const type = getUserTypeFromToken(data.access_token)

    removeUserCookies()

    const { access_token, refresh_token } = data

    accessTokenHelper.set(access_token)
    refreshTokenHelper.set(refresh_token)
    userTypeHelper.set(type)

    dispatch(
        setUserState(
            preferred_username,
            name,
            access_token,
            refresh_token,
            type,
            sub //userId
        )
    )

    // populate avatar store for the local student user
    const isStudent = type === userTypes.STUDENT
    isStudent && avatarStore.populate([sub])

    // now update auth info for qrcode
    await handleUpdateQRCodeInfo(dispatch, { accessToken: access_token })
}

export const performLogout = data => dispatch => {
    dispatch(userActions.logout())
    removeUserCookies()
}

export const checkLogin = data => async dispatch => {
    const access_token = accessTokenHelper.get()
    const refresh_token = refreshTokenHelper.get()

    if (access_token && refresh_token) {
        try {
            const { preferred_username, name, exp, sub } = jwtDecode(
                access_token || ''
            )
            const type = getUserTypeFromToken(access_token)

            const expired = isExpired(exp)
            if (expired) {
                const { exp: refresh_token_exp } = jwtDecode(
                    refresh_token || ''
                )
                const refreshTokenExpired = isExpired(refresh_token_exp)
                if (!refreshTokenExpired) {
                    dispatch(refreshToken())
                    return
                }
                dispatch(handleErrorInAuth())
                return
            }

            dispatch(
                setUserState(
                    preferred_username,
                    name,
                    access_token,
                    refresh_token,
                    type,
                    sub //userId
                )
            )

            // populate avatar store for the local student user
            const isStudent = type === userTypes.STUDENT
            isStudent && avatarStore.populate([sub])

            // now update auth info for qrcode
            await handleUpdateQRCodeInfo(dispatch, {
                accessToken: access_token,
            })
        } catch (e) {
            dispatch(handleErrorInAuth(e))
        }
    } else {
        dispatch(performLogout({}))
    }
}

export const refreshToken = () => async dispatch => {
    try {
        const refresh_token = refreshTokenHelper.get()
        if (refresh_token) {
            removeUserCookies()
            const data = await ohrAxiosOpen.post('/auth/refresh_token', {
                refresh_token,
            })
            if (data && data.data && data.data.success) {
                dispatch(performLogin(data.data))
                return
            }
        }
        dispatch(handleErrorInAuth())
    } catch (e) {
        dispatch(handleErrorInAuth(e))
    }
}
